(function () {
  'use strict';

  angular
      .module('tfc.retailer.ConsumerSampling', [])
      .constant("SplitRange", {
        regex : /[\<\>\-]/
      })
      .config(config);

      // @ngInject
      function config($stateProvider) {

        $stateProvider
            .state('consumer', {
              abstract : true,
              parent : 'pageWithMenu',
              url : '/consumer',
              data : {
                // TODO: This will change once we figure out the menu organization
                auth : { privilege : 'report.ConsumerSampling' },
                requireTerms:true
              },
              template : '<ui-view></ui-view>'
            })
            .state('consumer.sampling', {
              url : '/consumerSampling?brandKey',
              templateUrl : 'ConsumerSampling/ConsumerSampling.tmpl.html',
              controller : 'ConsumerSamplingCtrl as vm',
              data:{
                title:'Consumer Sampling',
                path:'consumer/consumerSampling'
              },
              resolve: {
                userBrands: function(BrandReports){
                  return BrandReports.findUserBrandNames();
                },
                selectedBrandKey: function(BrandReports, $stateParams){
                  return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
                    $stateParams.brandKey = selectedBrandKey;
                    return selectedBrandKey;
                  });
                },
                samplingSummary: function(BrandReports, selectedBrandKey, consumerSampling){
                  return consumerSampling( function(){
                    return BrandReports.getConsumerSamplingSummary(selectedBrandKey)
                  });
                },
                aggregationLogDetails : function(BrandReports) {
                  return BrandReports.getDashboardAggregationLogDetails('ConsumerSampling');
                },
                samplingGender: function(BrandReports, selectedBrandKey, consumerSampling) {
                  return consumerSampling( function(){
                    return BrandReports.getConsumerSamplingGenderDetails(selectedBrandKey);
                  });
                },
                samplingAgeRange: function(BrandReports, selectedBrandKey, consumerSampling){
                  return consumerSampling( function(){
                    return BrandReports.getConsumerSamplingAgeRangeDetails(selectedBrandKey);
                  });
                }
              }
            });
      }

})();